import React, { Component } from "react";
import ArrowForward from "site_media/images/arrow-forward.png";
import Navbar from "containers/Template/Navbar/Navbar";
import "containers/Template/Header/Mobile/Mobile_toolbar.css";
import { connect } from "react-redux";
import * as CONSTANT from "constants/text";
/**
 * @description Creates the a menu toolbar for mobile version
 * @class Mobile_toolbar
 * @extends React.Component
 * @type {Mobile_toolbar}
 * @example <Mobile_toolbar />
 * pre-condition: all the imports
 * post-condition: returns the menu page for mobile version
 * @param null
 * @returns {Mobile_toolbar}
 */

class Mobile_toolbar extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { toggleMenu, isMenuOpen } = this.props;
    return (
      <div
        className={
          isMenuOpen ? "mobile-toolbar-menu menu-open" : "mobile-toolbar-menu"
        }
      >
        <div className="header__logo-wrapper">
          <div className="header__logo">
            <a href="javascript:void(0)" onClick={toggleMenu}>
              <img src={ArrowForward} alt="Forward Arrow" />
            </a>
            <div className="header-menu-mobile"></div>
          </div>
          <div className="header-title">{CONSTANT.MENU}</div>
        </div>

        <div className="mobile-toolbar-menu__content">
          <div className="mobile-toolbar-menu__item">
            <a href="/account">{CONSTANT.MY_ACCOUNT}</a>
          </div>

          <div className="mobile-toolbar-menu__item">
            <a href="/blocked-users">{CONSTANT.BLOCKED_USERS}</a>
          </div>
          <div className="mobile-toolbar-menu__item">
            <a href="/payments">{CONSTANT.PAYMENT}</a>
          </div>

          <div className="mobile-toolbar-menu__item">
            <a href="/terms-and-conditions">{CONSTANT.T_AND_C}</a>
          </div>

          <div className="mobile-toolbar-menu__item">
            <a href="/security-and-privacy">{CONSTANT.SECURITY_PRIVACY}</a>
          </div>

          <div className="mobile-toolbar-menu__item">
            <a href="/logout" onClick={this.logout} className="logout-link">
              Logout
            </a>
          </div>
        </div>
        <Navbar />
      </div>
    );
  }
}

export default connect()(Mobile_toolbar);
